import React from 'react';
import { bookingSteps } from '../data/content';
import Reveal from './Reveal';
import './HowItWorks.css';

/** Postup rezervácie v štyroch krokoch. */
export default function HowItWorks() {
  return (
    <section className="section section--gray" id="ako-to-funguje">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Ako to funguje</span>
          <h2>Ako prebieha prenájom</h2>
        </Reveal>

        <ol className="steps">
          {bookingSteps.map((step, index) => (
            <Reveal key={step.title} delay={Math.min(index * 0.1, 0.3)}>
              <li className="steps__item">
                <span className="steps__number">{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>

        <Reveal>
          <p className="steps__note">
            Na cestovanie v campervane nepotrebuješ predchádzajúce skúsenosti s kempovaním.
            Všetko dôležité ti ukážeme a počas prenájmu máš k dispozícii prehľadný manuál. Stále sa nám môžeš ozvať a poradíme ti, ako si užiť cestovanie naplno.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
